module.exports = __webpack_public_path__ + "img/transfer26.c09cebb8.jpeg";